export const ProductType = 'RPDMENU';

export enum ProductPermissions {
  MENU = 'MENU',
}

export const APP_COMPONENT_WITHOUT_SUBMENU = ['DASHBOARD'];
